import React from 'react';
import { FormattedNumber } from 'react-intl';

import { Table as AntdTable } from 'antd';
import type { ColumnsType } from 'antd/es/table';

import type { IPartnerDetailsCommissions } from 'v2/interfaces/reports/partnerCommissions';

interface IProps {
  commissions: IPartnerDetailsCommissions[];
}

const columns: ColumnsType<IPartnerDetailsCommissions> = [
  {
    title: 'Produto',
    key: 'product',
    align: 'left',
    render: (_, record) => `${record.product.id} - ${record.product.title}`
  },
  {
    title: 'Comissões',
    dataIndex: 'total_commissions',
    key: 'total_commissions',
    align: 'left'
  },
  {
    title: 'Ganho líquido',
    key: 'net_gain',
    align: 'right',
    width: 160,
    className: 'pr-[60px]',
    onHeaderCell: () => ({ className: 'pr-[60px]' }),
    render: (_, record) => <FormattedNumber value={record.net_gain} format='BRL' />
  }
];

export const Table = ({ commissions }: IProps) => {
  return (
    <div className='mt-6 rounded-sm border border-[#ECEFF1] [&_.ant-table-tbody>tr>td]:p-4 [&_.ant-table-tbody>tr>td]:text-sm [&_.ant-table-tbody>tr>td]:text-[#37474F] [&_.ant-table-thead>tr>th]:bg-white [&_.ant-table-thead>tr>th]:p-4 [&_.ant-table-thead>tr>th]:text-xs [&_.ant-table-thead>tr>th]:font-normal [&_.ant-table-thead>tr>th]:text-[#37474F]'>
      <AntdTable<IPartnerDetailsCommissions>
        bordered={false}
        columns={columns}
        dataSource={commissions ?? []}
        pagination={false}
        rowKey={record => record.product.id}
        scroll={{ y: 348 }}
        size='middle'
      />
    </div>
  );
};
